
// app
import AppHeader from './app/app-header'
// line
import MarginLine from './line/margin-line'
// progress
import CircleProgress from './progress/circle-progress'

// form
import FormEntity from './view/form-entity/index'
import FormField from './view/form-entity/form-field/index'
import FormSubmit from './view/form-entity/form-submit/index' // 表单提交按钮
import FormButtonBottom from './view/form-entity/form-button-buttom/index' // 表单底部按钮（非提交）

// listbox
import Listbox from './view/listbox/index'
import ListboxItem from './view/listbox/listbox-item/index'

// image
import Iconfont from './image/iconfont'

const components = {
  // app
  AppHeader, // 头部组件
  // line
  MarginLine, // 间隔线
  // progress
  CircleProgress, // 圆形进度
  // form
  FormEntity, // 表单实体
  FormField, // [1]表单字段
  FormSubmit, // [2] 表单提交
  FormButtonBottom, // 表单底部按钮（可单独存在）
  // listbox
  Listbox, // 列表框
  ListboxItem, // [1] 列表框的项
  // image
  Iconfont // 字体图标
}

export default {
  install(Vue) {
    Object.keys(components).forEach(key => {
      Vue.component(components[key].name, components[key])
    })
  }
}
